module.exports = __webpack_public_path__ + "img/sign.b6986b07.png";